import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import AIValuation from "@/components/landing/AIValuation";
import FeaturedListings from "@/components/landing/FeaturedListings";
import RevvPass from "@/components/landing/RevvPass";
import RiderCulture from "@/components/landing/RiderCulture";
import MeetDash from "@/components/landing/MeetDash";
import TrustStats from "@/components/landing/TrustStats";
import Footer from "@/components/landing/Footer";
import CursorGlow from "@/components/landing/CursorGlow";
import ScrollProgress from "@/components/landing/ScrollProgress";

export default function Landing() {
  useEffect(() => {
    document.title = "Biker Boulevard — The Next Ride Starts Here";
  }, []);

  return (
    <main data-testid="landing-page" className="relative bg-[#0D0F12] text-white min-h-screen overflow-x-hidden">
      <CursorGlow />
      <ScrollProgress />
      <Navbar />
      <Hero />
      <AIValuation />
      <FeaturedListings />
      <MeetDash />
      <RevvPass />
      <RiderCulture />
      <TrustStats />
      <Footer />
    </main>
  );
}
